import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=f19c7c5c&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=ts&"
export * from "./AboutUs.vue?vue&type=script&lang=ts&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=f19c7c5c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19c7c5c",
  null
  
)

export default component.exports